'use client';

import { PayPalScriptProvider, ReactPayPalScriptOptions } from '@paypal/react-paypal-js';
import { env } from '@/utils/env';

export const DEFAULT_PAYPAL_OPTIONS: Readonly<ReactPayPalScriptOptions> = {
  clientId: env.NEXT_PUBLIC_PAYPAL_CLIENT_ID || '',
  currency: env.NEXT_PUBLIC_DEFAULT_CURRENCY,
  components: 'messages,buttons',
  disableFunding: 'credit,card',
};

export function PaypalGlobalScriptProvider({ children }: { children: React.ReactNode }) {
  // 默认使用 deferLoading，PaypalButton 触发加载脚本
  // options 给的是默认值，PaypalButton 使用 hook 更新
  return (
    <PayPalScriptProvider options={DEFAULT_PAYPAL_OPTIONS} deferLoading>
      {children}
    </PayPalScriptProvider>
  );
}
